(ns ballot-scout-v2-frontend.components.search
  (:require [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]))

(defn clear-button [on-click & [classes]]
  [:button {:class "clear"
            :type "button"
            :on-click on-click}
   [icon ::icon/times-circle {:class classes}]])
